import React from 'react';
import UserFullName from '../userFullName';
import UserGridContextMenu from '../userGridContextMenu';
import IconComponent from '../../portal/iconComponent';


export const formatUserStatus = (cellText, rowData) => 
{
    const userIconClassName = rowData.active ? 'active-user-icon': 'none-active-user-icon';
    const userIconTitle = rowData.active ? '': 'User is disabled';
    return (<div data-cy={userIconClassName} style={{textAlign: 'center'}}>
               <IconComponent iconClassName={userIconClassName} title={userIconTitle}/>
            </div>);
};
   

export const formatFullName = (fullName, rowData) => 
        <div id={rowData.id} className='user-name-column users-grid library-name-link ellipsis'>
            <span className='user-full-name' title={fullName}>
                {fullName}
            </span>
        </div>;


export const formatFullNameAndStatus = (cellText, rowData) => 
    <div className='user-name-column library-name-link ellipsis'>
        <UserFullName id={rowData.id} fullName={cellText} active={rowData.active}/>
    </div>;

export const formatGeneric = (cellText) => 
    <div
        className='general-table-column ellipsis'
        title={cellText}
    >
        {cellText}
    </div>;
    
export const formatRowMenu = (userId, rowData) =>
    <UserGridContextMenu
        userId={userId}
        twoFAExemption={rowData.twoFAExemption}
		accessToUi={rowData.accessToUi}
        userName={rowData.userName}
        authenticationProviderType={rowData.authenticationProviderType}
    />;
